// Description: This file is used to set the magic variable --gmf-scrollbar-width on body

const resizeObserver = new ResizeObserver(() => {
    const modal = document.querySelector('.gmf-modal-body');

    if (modal) {
        return;
    }

    if (process.env.NODE_ENV === 'development') {
        console.warn('[DEV] magicVariableManager.js: resizeObserver triggered');
    }

    setBodyVariable();
});

function setBodyVariable () {
    const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
    document.documentElement.style.setProperty('--gmf-scrollbar-width', scrollbarWidth + 'px');
}

resizeObserver.observe(window.document.body);
